import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { useCallback, useState } from "react";
import { storage } from "../firebase/firebase";

const useUploadDocument = () => {
  const [url, setUrl] = useState(null);
  const [file, setFile] = useState(null);

  const onChange = useCallback((e, type, setLoading) => {
    const file = e.target.files[0];
    setFile(e.target.files[0]);
    setLoading(true);
    const imageRef = ref(storage, `vault/${type}/${file.name}`);
    uploadBytes(imageRef, file).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((url) => {
        setUrl(url);
        e.target.value = null;
      });
    });
  }, []);


  const onNewDoc = useCallback((file, type, setLoading) => {
    setLoading(true);
    const imageRef = ref(storage, `vault/${type}/${file.name}`);
    uploadBytes(imageRef, file).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((url) => {
        setUrl(url);
      });
    });
  }, []);

  const doc = {
    url,
    file,
    onNewDoc,
  };

  return { onChange, doc, setUrl };
};

export default useUploadDocument;
